import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";

export const IconBlankPagePortrait: React.FC<CentralIconBaseProps> = (props) => {
  return <CentralIconBase {...props} ariaLabel="blank-page-portrait"><path d="M4.75 21.25V2.75H19.25V15.5972V15.9643C19.25 16.7267 19.0019 17.4686 18.5429 18.0786C17.0405 20.075 14.6826 21.25 12.1786 21.25H5.69717H4.75Z" stroke="currentColor" strokeWidth="1.5"/><path d="M19.2501 15.5977C19.2501 18.1671 15.6407 18.1671 14.0938 17.1393L12.9893 18.2401C11.0553 20.1676 8.43231 21.2504 5.69727 21.2504" stroke="currentColor" strokeWidth="1.5"/></CentralIconBase>;
};

export default IconBlankPagePortrait;
